/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateDeviceAdminDto,
  DeviceDetailDto,
  DeviceListItemDto,
  DevicePartnerDto,
  DevicesAdminControllerListDevicesParams,
  DevicesControllerSetDeviceConfig201,
  SetDeviceConfigDto,
  SetDevicePartnerDto,
  UpdateDeviceConfigDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Sets a single configuration key on the device to the given boolean or string value, merging it into the existing device config.
 * @summary Set a device configuration value
 */
export type devicesControllerSetDeviceConfigResponse201 = {
  data: DevicesControllerSetDeviceConfig201
  status: 201
}

export type devicesControllerSetDeviceConfigResponse401 = {
  data: void
  status: 401
}

export type devicesControllerSetDeviceConfigResponse404 = {
  data: void
  status: 404
}
    
export type devicesControllerSetDeviceConfigResponseSuccess = (devicesControllerSetDeviceConfigResponse201) & {
  headers: Headers;
};
export type devicesControllerSetDeviceConfigResponseError = (devicesControllerSetDeviceConfigResponse401 | devicesControllerSetDeviceConfigResponse404) & {
  headers: Headers;
};

export type devicesControllerSetDeviceConfigResponse = (devicesControllerSetDeviceConfigResponseSuccess | devicesControllerSetDeviceConfigResponseError)

export const getDevicesControllerSetDeviceConfigUrl = (deviceId: string,) => {


  

  return `/devices/${deviceId}/config`
}

export const devicesControllerSetDeviceConfig = async (deviceId: string,
    setDeviceConfigDto: SetDeviceConfigDto, options?: RequestInit): Promise<devicesControllerSetDeviceConfigResponse> => {
  
  return customFetch<devicesControllerSetDeviceConfigResponse>(getDevicesControllerSetDeviceConfigUrl(deviceId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setDeviceConfigDto,)
  }
);}




export const getDevicesControllerSetDeviceConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,{deviceId: string;data: SetDeviceConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,{deviceId: string;data: SetDeviceConfigDto}, TContext> => {

const mutationKey = ['devicesControllerSetDeviceConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, {deviceId: string;data: SetDeviceConfigDto}> = (props) => {
          const {deviceId,data} = props ?? {};

          return  devicesControllerSetDeviceConfig(deviceId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesControllerSetDeviceConfigMutationResult = NonNullable<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>>
    export type DevicesControllerSetDeviceConfigMutationBody = SetDeviceConfigDto
    export type DevicesControllerSetDeviceConfigMutationError = void

    /**
 * @summary Set a device configuration value
 */
export const useDevicesControllerSetDeviceConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>, TError,{deviceId: string;data: SetDeviceConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesControllerSetDeviceConfig>>,
        TError,
        {deviceId: string;data: SetDeviceConfigDto},
        TContext
      > => {

      const mutationOptions = getDevicesControllerSetDeviceConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Lists all devices, newest first. Optional device_id search. Artic admin only.
 * @summary List devices
 */
export type devicesAdminControllerListDevicesResponse200 = {
  data: DeviceListItemDto[]
  status: 200
}

export type devicesAdminControllerListDevicesResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerListDevicesResponse403 = {
  data: void
  status: 403
}
    
export type devicesAdminControllerListDevicesResponseSuccess = (devicesAdminControllerListDevicesResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerListDevicesResponseError = (devicesAdminControllerListDevicesResponse401 | devicesAdminControllerListDevicesResponse403) & {
  headers: Headers;
};

export type devicesAdminControllerListDevicesResponse = (devicesAdminControllerListDevicesResponseSuccess | devicesAdminControllerListDevicesResponseError)

export const getDevicesAdminControllerListDevicesUrl = (params?: DevicesAdminControllerListDevicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/admin/devices?${stringifiedParams}` : `/admin/devices`
}

export const devicesAdminControllerListDevices = async (params?: DevicesAdminControllerListDevicesParams, options?: RequestInit): Promise<devicesAdminControllerListDevicesResponse> => {
  
  return customFetch<devicesAdminControllerListDevicesResponse>(getDevicesAdminControllerListDevicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDevicesAdminControllerListDevicesQueryKey = (params?: DevicesAdminControllerListDevicesParams,) => {
    return [
    `/admin/devices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDevicesAdminControllerListDevicesQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListDevicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>> = ({ signal }) => devicesAdminControllerListDevices(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerListDevicesQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>>
export type DevicesAdminControllerListDevicesQueryError = void


export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params: undefined |  DevicesAdminControllerListDevicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListDevices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List devices
 */

export function useDevicesAdminControllerListDevices<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerListDevicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List devices
 */
export const prefetchDevicesAdminControllerListDevicesQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 queryClient: QueryClient, params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerListDevicesQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getDevicesAdminControllerListDevicesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListDevicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>> = ({ signal }) => devicesAdminControllerListDevices(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerListDevicesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>>
export type DevicesAdminControllerListDevicesSuspenseQueryError = void


export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params: undefined |  DevicesAdminControllerListDevicesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List devices
 */

export function useDevicesAdminControllerListDevicesSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError = void>(
 params?: DevicesAdminControllerListDevicesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListDevices>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerListDevicesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Creates a device with a generated device_auth_id and default config. device_id must be unique. Artic admin only.
 * @summary Register a device
 */
export type devicesAdminControllerCreateDeviceResponse201 = {
  data: DeviceDetailDto
  status: 201
}

export type devicesAdminControllerCreateDeviceResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerCreateDeviceResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerCreateDeviceResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerCreateDeviceResponse409 = {
  data: void
  status: 409
}
    
export type devicesAdminControllerCreateDeviceResponseSuccess = (devicesAdminControllerCreateDeviceResponse201) & {
  headers: Headers;
};
export type devicesAdminControllerCreateDeviceResponseError = (devicesAdminControllerCreateDeviceResponse400 | devicesAdminControllerCreateDeviceResponse401 | devicesAdminControllerCreateDeviceResponse403 | devicesAdminControllerCreateDeviceResponse409) & {
  headers: Headers;
};

export type devicesAdminControllerCreateDeviceResponse = (devicesAdminControllerCreateDeviceResponseSuccess | devicesAdminControllerCreateDeviceResponseError)

export const getDevicesAdminControllerCreateDeviceUrl = () => {


  

  return `/admin/devices`
}

export const devicesAdminControllerCreateDevice = async (createDeviceAdminDto: CreateDeviceAdminDto, options?: RequestInit): Promise<devicesAdminControllerCreateDeviceResponse> => {
  
  return customFetch<devicesAdminControllerCreateDeviceResponse>(getDevicesAdminControllerCreateDeviceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createDeviceAdminDto,)
  }
);}




export const getDevicesAdminControllerCreateDeviceMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,{data: CreateDeviceAdminDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,{data: CreateDeviceAdminDto}, TContext> => {

const mutationKey = ['devicesAdminControllerCreateDevice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, {data: CreateDeviceAdminDto}> = (props) => {
          const {data} = props ?? {};

          return  devicesAdminControllerCreateDevice(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerCreateDeviceMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>>
    export type DevicesAdminControllerCreateDeviceMutationBody = CreateDeviceAdminDto
    export type DevicesAdminControllerCreateDeviceMutationError = void

    /**
 * @summary Register a device
 */
export const useDevicesAdminControllerCreateDevice = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>, TError,{data: CreateDeviceAdminDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerCreateDevice>>,
        TError,
        {data: CreateDeviceAdminDto},
        TContext
      > => {

      const mutationOptions = getDevicesAdminControllerCreateDeviceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Artic admin only.
 * @summary Get a device by id
 */
export type devicesAdminControllerGetDeviceResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerGetDeviceResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerGetDeviceResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerGetDeviceResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerGetDeviceResponse404 = {
  data: void
  status: 404
}
    
export type devicesAdminControllerGetDeviceResponseSuccess = (devicesAdminControllerGetDeviceResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerGetDeviceResponseError = (devicesAdminControllerGetDeviceResponse400 | devicesAdminControllerGetDeviceResponse401 | devicesAdminControllerGetDeviceResponse403 | devicesAdminControllerGetDeviceResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerGetDeviceResponse = (devicesAdminControllerGetDeviceResponseSuccess | devicesAdminControllerGetDeviceResponseError)

export const getDevicesAdminControllerGetDeviceUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}`
}

export const devicesAdminControllerGetDevice = async (deviceAuthId: string, options?: RequestInit): Promise<devicesAdminControllerGetDeviceResponse> => {
  
  return customFetch<devicesAdminControllerGetDeviceResponse>(getDevicesAdminControllerGetDeviceUrl(deviceAuthId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDevicesAdminControllerGetDeviceQueryKey = (deviceAuthId?: string,) => {
    return [
    `/admin/devices/${deviceAuthId}`
    ] as const;
    }

    
export const getDevicesAdminControllerGetDeviceQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerGetDeviceQueryKey(deviceAuthId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>> = ({ signal }) => devicesAdminControllerGetDevice(deviceAuthId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(deviceAuthId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerGetDeviceQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>>
export type DevicesAdminControllerGetDeviceQueryError = void


export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a device by id
 */

export function useDevicesAdminControllerGetDevice<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerGetDeviceQueryOptions(deviceAuthId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get a device by id
 */
export const prefetchDevicesAdminControllerGetDeviceQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 queryClient: QueryClient, deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerGetDeviceQueryOptions(deviceAuthId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getDevicesAdminControllerGetDeviceSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerGetDeviceQueryKey(deviceAuthId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>> = ({ signal }) => devicesAdminControllerGetDevice(deviceAuthId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerGetDeviceSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>>
export type DevicesAdminControllerGetDeviceSuspenseQueryError = void


export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get a device by id
 */

export function useDevicesAdminControllerGetDeviceSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerGetDevice>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerGetDeviceSuspenseQueryOptions(deviceAuthId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Shallow-merges the supplied config over the existing one. Artic admin only.
 * @summary Update device config
 */
export type devicesAdminControllerUpdateConfigResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerUpdateConfigResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerUpdateConfigResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerUpdateConfigResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerUpdateConfigResponse404 = {
  data: void
  status: 404
}
    
export type devicesAdminControllerUpdateConfigResponseSuccess = (devicesAdminControllerUpdateConfigResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerUpdateConfigResponseError = (devicesAdminControllerUpdateConfigResponse400 | devicesAdminControllerUpdateConfigResponse401 | devicesAdminControllerUpdateConfigResponse403 | devicesAdminControllerUpdateConfigResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerUpdateConfigResponse = (devicesAdminControllerUpdateConfigResponseSuccess | devicesAdminControllerUpdateConfigResponseError)

export const getDevicesAdminControllerUpdateConfigUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}/config`
}

export const devicesAdminControllerUpdateConfig = async (deviceAuthId: string,
    updateDeviceConfigDto: UpdateDeviceConfigDto, options?: RequestInit): Promise<devicesAdminControllerUpdateConfigResponse> => {
  
  return customFetch<devicesAdminControllerUpdateConfigResponse>(getDevicesAdminControllerUpdateConfigUrl(deviceAuthId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateDeviceConfigDto,)
  }
);}




export const getDevicesAdminControllerUpdateConfigMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,{deviceAuthId: string;data: UpdateDeviceConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,{deviceAuthId: string;data: UpdateDeviceConfigDto}, TContext> => {

const mutationKey = ['devicesAdminControllerUpdateConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, {deviceAuthId: string;data: UpdateDeviceConfigDto}> = (props) => {
          const {deviceAuthId,data} = props ?? {};

          return  devicesAdminControllerUpdateConfig(deviceAuthId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerUpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>>
    export type DevicesAdminControllerUpdateConfigMutationBody = UpdateDeviceConfigDto
    export type DevicesAdminControllerUpdateConfigMutationError = void

    /**
 * @summary Update device config
 */
export const useDevicesAdminControllerUpdateConfig = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>, TError,{deviceAuthId: string;data: UpdateDeviceConfigDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerUpdateConfig>>,
        TError,
        {deviceAuthId: string;data: UpdateDeviceConfigDto},
        TContext
      > => {

      const mutationOptions = getDevicesAdminControllerUpdateConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Nulls device_metadata.current_station. Artic admin only.
 * @summary Clear the device current station
 */
export type devicesAdminControllerClearStationResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerClearStationResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerClearStationResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerClearStationResponse404 = {
  data: void
  status: 404
}
    
export type devicesAdminControllerClearStationResponseSuccess = (devicesAdminControllerClearStationResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerClearStationResponseError = (devicesAdminControllerClearStationResponse401 | devicesAdminControllerClearStationResponse403 | devicesAdminControllerClearStationResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerClearStationResponse = (devicesAdminControllerClearStationResponseSuccess | devicesAdminControllerClearStationResponseError)

export const getDevicesAdminControllerClearStationUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}/clear-station`
}

export const devicesAdminControllerClearStation = async (deviceAuthId: string, options?: RequestInit): Promise<devicesAdminControllerClearStationResponse> => {
  
  return customFetch<devicesAdminControllerClearStationResponse>(getDevicesAdminControllerClearStationUrl(deviceAuthId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDevicesAdminControllerClearStationMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,{deviceAuthId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,{deviceAuthId: string}, TContext> => {

const mutationKey = ['devicesAdminControllerClearStation'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, {deviceAuthId: string}> = (props) => {
          const {deviceAuthId} = props ?? {};

          return  devicesAdminControllerClearStation(deviceAuthId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerClearStationMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>>
    
    export type DevicesAdminControllerClearStationMutationError = void

    /**
 * @summary Clear the device current station
 */
export const useDevicesAdminControllerClearStation = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearStation>>, TError,{deviceAuthId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerClearStation>>,
        TError,
        {deviceAuthId: string},
        TContext
      > => {

      const mutationOptions = getDevicesAdminControllerClearStationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Nulls device_metadata.current_job_card / current_job_card_ids / current_batch_process_id. Artic admin only.
 * @summary Clear the device current jobs and batch
 */
export type devicesAdminControllerClearJobsResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerClearJobsResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerClearJobsResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerClearJobsResponse404 = {
  data: void
  status: 404
}
    
export type devicesAdminControllerClearJobsResponseSuccess = (devicesAdminControllerClearJobsResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerClearJobsResponseError = (devicesAdminControllerClearJobsResponse401 | devicesAdminControllerClearJobsResponse403 | devicesAdminControllerClearJobsResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerClearJobsResponse = (devicesAdminControllerClearJobsResponseSuccess | devicesAdminControllerClearJobsResponseError)

export const getDevicesAdminControllerClearJobsUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}/clear-jobs`
}

export const devicesAdminControllerClearJobs = async (deviceAuthId: string, options?: RequestInit): Promise<devicesAdminControllerClearJobsResponse> => {
  
  return customFetch<devicesAdminControllerClearJobsResponse>(getDevicesAdminControllerClearJobsUrl(deviceAuthId),
  {      
    ...options,
    method: 'POST'
    
    
  }
);}




export const getDevicesAdminControllerClearJobsMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,{deviceAuthId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,{deviceAuthId: string}, TContext> => {

const mutationKey = ['devicesAdminControllerClearJobs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, {deviceAuthId: string}> = (props) => {
          const {deviceAuthId} = props ?? {};

          return  devicesAdminControllerClearJobs(deviceAuthId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerClearJobsMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>>
    
    export type DevicesAdminControllerClearJobsMutationError = void

    /**
 * @summary Clear the device current jobs and batch
 */
export const useDevicesAdminControllerClearJobs = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>, TError,{deviceAuthId: string}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerClearJobs>>,
        TError,
        {deviceAuthId: string},
        TContext
      > => {

      const mutationOptions = getDevicesAdminControllerClearJobsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Artic admin only.
 * @summary List partners linked to a device
 */
export type devicesAdminControllerListPartnersResponse200 = {
  data: DevicePartnerDto[]
  status: 200
}

export type devicesAdminControllerListPartnersResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerListPartnersResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerListPartnersResponse404 = {
  data: void
  status: 404
}
    
export type devicesAdminControllerListPartnersResponseSuccess = (devicesAdminControllerListPartnersResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerListPartnersResponseError = (devicesAdminControllerListPartnersResponse401 | devicesAdminControllerListPartnersResponse403 | devicesAdminControllerListPartnersResponse404) & {
  headers: Headers;
};

export type devicesAdminControllerListPartnersResponse = (devicesAdminControllerListPartnersResponseSuccess | devicesAdminControllerListPartnersResponseError)

export const getDevicesAdminControllerListPartnersUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}/partners`
}

export const devicesAdminControllerListPartners = async (deviceAuthId: string, options?: RequestInit): Promise<devicesAdminControllerListPartnersResponse> => {
  
  return customFetch<devicesAdminControllerListPartnersResponse>(getDevicesAdminControllerListPartnersUrl(deviceAuthId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDevicesAdminControllerListPartnersQueryKey = (deviceAuthId?: string,) => {
    return [
    `/admin/devices/${deviceAuthId}/partners`
    ] as const;
    }

    
export const getDevicesAdminControllerListPartnersQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListPartnersQueryKey(deviceAuthId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>> = ({ signal }) => devicesAdminControllerListPartners(deviceAuthId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(deviceAuthId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerListPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>>
export type DevicesAdminControllerListPartnersQueryError = void


export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>,
          TError,
          Awaited<ReturnType<typeof devicesAdminControllerListPartners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List partners linked to a device
 */

export function useDevicesAdminControllerListPartners<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerListPartnersQueryOptions(deviceAuthId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List partners linked to a device
 */
export const prefetchDevicesAdminControllerListPartnersQuery = async <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 queryClient: QueryClient, deviceAuthId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getDevicesAdminControllerListPartnersQueryOptions(deviceAuthId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getDevicesAdminControllerListPartnersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDevicesAdminControllerListPartnersQueryKey(deviceAuthId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>> = ({ signal }) => devicesAdminControllerListPartners(deviceAuthId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DevicesAdminControllerListPartnersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>>
export type DevicesAdminControllerListPartnersSuspenseQueryError = void


export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List partners linked to a device
 */

export function useDevicesAdminControllerListPartnersSuspense<TData = Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError = void>(
 deviceAuthId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof devicesAdminControllerListPartners>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDevicesAdminControllerListPartnersSuspenseQueryOptions(deviceAuthId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Assigns a single owning partner (reconciling the partners_devices join to exactly that partner), or null to make it an Admin Device. Setting null is rejected (409) while the device still has partner links — admin all-access enforcement is deferred. Artic admin only.
 * @summary Set the device's owning partner
 */
export type devicesAdminControllerSetPartnerResponse200 = {
  data: DeviceDetailDto
  status: 200
}

export type devicesAdminControllerSetPartnerResponse400 = {
  data: void
  status: 400
}

export type devicesAdminControllerSetPartnerResponse401 = {
  data: void
  status: 401
}

export type devicesAdminControllerSetPartnerResponse403 = {
  data: void
  status: 403
}

export type devicesAdminControllerSetPartnerResponse404 = {
  data: void
  status: 404
}

export type devicesAdminControllerSetPartnerResponse409 = {
  data: void
  status: 409
}
    
export type devicesAdminControllerSetPartnerResponseSuccess = (devicesAdminControllerSetPartnerResponse200) & {
  headers: Headers;
};
export type devicesAdminControllerSetPartnerResponseError = (devicesAdminControllerSetPartnerResponse400 | devicesAdminControllerSetPartnerResponse401 | devicesAdminControllerSetPartnerResponse403 | devicesAdminControllerSetPartnerResponse404 | devicesAdminControllerSetPartnerResponse409) & {
  headers: Headers;
};

export type devicesAdminControllerSetPartnerResponse = (devicesAdminControllerSetPartnerResponseSuccess | devicesAdminControllerSetPartnerResponseError)

export const getDevicesAdminControllerSetPartnerUrl = (deviceAuthId: string,) => {


  

  return `/admin/devices/${deviceAuthId}/partner`
}

export const devicesAdminControllerSetPartner = async (deviceAuthId: string,
    setDevicePartnerDto: SetDevicePartnerDto, options?: RequestInit): Promise<devicesAdminControllerSetPartnerResponse> => {
  
  return customFetch<devicesAdminControllerSetPartnerResponse>(getDevicesAdminControllerSetPartnerUrl(deviceAuthId),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setDevicePartnerDto,)
  }
);}




export const getDevicesAdminControllerSetPartnerMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,{deviceAuthId: string;data: SetDevicePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,{deviceAuthId: string;data: SetDevicePartnerDto}, TContext> => {

const mutationKey = ['devicesAdminControllerSetPartner'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, {deviceAuthId: string;data: SetDevicePartnerDto}> = (props) => {
          const {deviceAuthId,data} = props ?? {};

          return  devicesAdminControllerSetPartner(deviceAuthId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DevicesAdminControllerSetPartnerMutationResult = NonNullable<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>>
    export type DevicesAdminControllerSetPartnerMutationBody = SetDevicePartnerDto
    export type DevicesAdminControllerSetPartnerMutationError = void

    /**
 * @summary Set the device's owning partner
 */
export const useDevicesAdminControllerSetPartner = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>, TError,{deviceAuthId: string;data: SetDevicePartnerDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof devicesAdminControllerSetPartner>>,
        TError,
        {deviceAuthId: string;data: SetDevicePartnerDto},
        TContext
      > => {

      const mutationOptions = getDevicesAdminControllerSetPartnerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    